(function () {
  function fixMegaMenuBrandGrid(grid) {
    if (!grid || !grid.closest('.mega-menu__brands')) return;

    var items = grid.querySelectorAll(
      '.mega-menu-brand__item, .home-shop-by-brand__item'
    );
    var colCount = Math.min(Math.max(items.length, 1), 4);

    grid.style.setProperty('display', 'grid', 'important');
    grid.style.setProperty(
      'grid-template-columns',
      'repeat(' + colCount + ', minmax(0, 1fr))',
      'important'
    );
    grid.style.setProperty('gap', '0.5rem', 'important');
    grid.style.setProperty('width', '100%', 'important');
    grid.style.setProperty('margin', '0', 'important');

    items.forEach(function (item) {
      item.style.setProperty('overflow', 'visible', 'important');
      item.style.setProperty('min-width', '0', 'important');
      var logo = item.querySelector(
        '.mega-menu-brand__logo, .home-shop-by-brand__logo'
      );
      if (logo) {
        logo.style.setProperty('overflow', 'visible', 'important');
      }
      var img = item.querySelector('img');
      if (img) {
        img.style.setProperty('max-height', '40px', 'important');
        img.style.setProperty('object-fit', 'contain', 'important');
      }
    });

    var wrap = grid.closest('.mega-menu__brands');
    var content = wrap && wrap.closest('.mega-menu__content');
    if (wrap) wrap.style.setProperty('overflow', 'visible', 'important');
    if (content) {
      content.style.setProperty('overflow', 'visible', 'important');
      content.style.setProperty('max-height', 'none', 'important');
    }
  }

  window.fixMegaMenuBrandGrid = fixMegaMenuBrandGrid;

  function scanMegaMenuBrandGrids() {
    document
      .querySelectorAll(
        '.mega-menu__brands .mega-menu-brand__grid, .mega-menu__brands .home-shop-by-brand__grid'
      )
      .forEach(fixMegaMenuBrandGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanMegaMenuBrandGrids);
  } else {
    scanMegaMenuBrandGrids();
  }

  document.addEventListener('shopify:section:load', scanMegaMenuBrandGrids);

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var target = mutations[i].target;
      if (
        target.closest &&
        target.closest('.mega-menu__brands') &&
        (mutations[i].type === 'childList' || mutations[i].type === 'attributes')
      ) {
        scanMegaMenuBrandGrids();
        return;
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'hidden'],
  });
})();
